var s = window.s || {};

s.paginatorHandler = function($target, data){
	var $button = $(s.subString("<!-- #paginator-button -->", "<!-- /#paginator-button -->", data.content)).find("a");
	if ($button.length && $button.attr("href") !== "#") {
		s.dom.$main.find("#paginator-button")
			.attr("href", $button.attr("href"))
			.removeClass("hide");
	} else {
		s.dom.$main.find("#paginator-button")
			.addClass("hide");
	}
	
	var content = s.subString("<!-- #paginator-target -->", "<!-- /#paginator-target -->", data.content);
	$target.append(content);
	s.initFlexImage($target);
};

s.paginatorHandlerEvents = function($target, data){
	var $button = $(s.subString("<!-- #paginator-button -->", "<!-- /#paginator-button -->", data.content)).find("a");
	if ($button.length && $button.attr("href") !== "#") {
		s.dom.$main.find("#paginator-button")
			.attr("href", $button.attr("href"))
			.removeClass("hide");
	} else {
		s.dom.$main.find("#paginator-button")
			.addClass("hide");
	}

	var content = s.subString("<!-- #paginator-target-events -->", "<!-- /#paginator-target-events -->", data.content);
	$target.append(content);
	s.initFlexImage($target);
};

s.paginatorHandlerTour = function($target, data){
	var $button = $(s.subString("<!-- #paginator-button-tour -->", "<!-- /#paginator-button-tour -->", data.content)).find("a");
	if ($button.length && $button.attr("href") !== "#") {
		s.dom.$main.find("#paginator-button-tour")
			.attr("href", $button.attr("href"))
			.removeClass("hide");
	} else {
		s.dom.$main.find("#paginator-button-tour")
			.addClass("hide");
	}

	var content = s.subString("<!-- #paginator-target-tour -->", "<!-- /#paginator-target-tour -->", data.content);
	$target.append(content);
	s.initFlexImage($target);
};

s.initSearchControl = function(context){
	var $holder = context.find(".search-item");
	var $form = $holder.find(".search-form");
	var $containerHolder = $holder.closest(".container");
	
	$holder.find(".search-opener").on("click", function(e){
		var $this = $(this);
		if ( ! $holder.is(':animated')) {
			if ($holder.hasClass('opened')) {
				$form.animate({
					'width':0
				}, 300, function(){
					$holder.removeClass('opened')
				})
			} else {
				if (s.tabletFix.is(':hidden') && s.mobileFix.is(':hidden')){
					$form.animate({
						'width':400
					}, 300, function(){
						$holder.addClass('opened')
					})
				}
				if (s.tabletFix.is(':visible') && s.mobileFix.is(':hidden')){
					$form.animate({
						'width': ($containerHolder.width() - 209)
					}, 300, function(){
						$holder.addClass('opened')
					})
				}
				if (s.tabletFix.is(':hidden') && s.mobileFix.is(':visible')){
					$form.animate({
						'width': ($containerHolder.width() - 139)
					}, 300, function(){
						$holder.addClass('opened')
					})
				}
			}
		}
	});
	
	function initSearchPositionFix() {
		if ($holder.hasClass('opened')){
			if (s.tabletFix.is(':hidden') && s.mobileFix.is(':hidden')){
				$form.css({
					'width':400
				})
			}
			if (s.tabletFix.is(':visible') && s.mobileFix.is(':hidden')){
				$form.css({
					'width': ($containerHolder.width() - 209)
				})
			}
			if (s.tabletFix.is(':hidden') && s.mobileFix.is(':visible')){
				$form.css({
					'width': ($containerHolder.width() - 139)
				})
			}
		}
	}
	s.dom.$window.resize(function(){
		initSearchPositionFix();
	});
};

s.initSiteSearch = function(){
	var $holder = s.dom.$body.find("#header");
	var $form = $holder.find("form.search");
	var $searchContainer = $holder.find('.search-item');

	function closeSearchForm() {
		if ($searchContainer.hasClass('opened')) {
			$form.animate({width: 0}, 300, function () {
				$searchContainer.removeClass('opened');
			});
		}
	}

	function submitForm() {
		closeSearchForm();

		var link = $form.attr("action")+"?s="+encodeURIComponent($form.find("input").val());

		s.ajax.load(link, s.dom.$main);
		$form.find("input").val('');
	}

	$form.submit(function(e){
		e.preventDefault();
		submitForm();
	});
};

s.initPromoBanner = function(context){
	context = context || s.dom.$main;
	var $holder = context.find(".promo-block");

	$holder.children(".slider").each(function(){
		$(this).bxSlider({
			speed: 700,
			infiniteLoop: true,
			hideControlOnEnd: true,
			auto: false,
			pause: 5000,
			adaptiveHeight: true,
			touchEnabled: (navigator.maxTouchPoints === undefined || navigator.maxTouchPoints > 0),
			onSliderLoad: function(){
				$holder.find('.bx-pager-link.active')
					.parent().addClass('active');
			},
			onSlideBefore: function($slideElement, oldIndex, newIndex){
				$holder.find('.bx-pager-item')
					.eq(newIndex).addClass('active')
						.siblings().removeClass('active');
			},
			onSlideAfter: function($slideElement, oldIndex, newIndex){
				$holder.find('.bx-pager-item')
					.eq(newIndex).addClass('active')
						.siblings().removeClass('active');
			},
			pager: true
		});
	});
	s.initFlexImage($holder);
	s.dom.$window.on("resize.page", function(){
		$holder.each(function(){
			$(this).find('.bx-pager-link.active')
				.parent().addClass('active')
					.siblings().removeClass('active');
		});
	});
};

s.filterHandler = function($target, data){
	var $button = $(s.subString("<!-- #paginator-button -->", "<!-- /#paginator-button -->", data.content)).find("a");
	if ($button.length && $button.attr("href") !== "#") {
		s.dom.$body.find("#paginator-button")
			.attr("href", $button.attr("href"))
			.removeClass("hide");
	} else {
		s.dom.$body.find("#paginator-button")
			.addClass("hide");
	}
	
	var content = s.subString("<!-- #paginator-target -->", "<!-- /#paginator-target -->", data.content);
	$target.html(content);
};

s.initTypeFilter = function(context){
	var $holder = context.find(".filter-panel #order");
	var baseURL = $holder.closest(".filter-panel").data("action");
	var $target = context.find("#paginator-target");
	
	var $year = context.find(".filter-panel #year");
	var $month = context.find(".filter-panel #month");
	
	$holder.on("change", function(){
		var $this = $(this);
		var link = baseURL;
		
		if ($year.val() !== "" && $month.val() !== "") {
			link += "?filter[year]="+$year.val()+"&filter[month]="+$month.val();
		}
		
		if ($this.val()) {
			link += (link.indexOf("?") > 0) ? "&" : "?";
			link += "order="+$this.val();
		}
		
		s.ajax.load(link, $target, {
			scrollToTarget: false,
			counters: false,
			insertHandler: "filterHandler"
		});
	});
};

s.initDateFilterReleases = function(context, options){
	var $holder = context.find("#js-date-filter");
	var $year = $holder.find("#year");
	var $month = $holder.find("#month");
	var $monthHolder = $holder.find(".filter-month-row");
	var $order = context.find("#order");
	var $button = $holder.find("#js-filter-button");
	var $buttonReset = $holder.find("#js-filter-reset-button");
	var baseURL = $holder.data("action");
	var $target = context.find("#paginator-target");

	if ($year.val() || $month.val()) {
		$buttonReset.closest('.btn-reset').show();
	}

	$year.on("change", function(){
		$month.empty();
		var val = $(this).val();
		if (val) {
			$.each(options[val], function(key, value){
				$month.append("<option value=\""+key+"\">"+value+"</option>");
			});
		} 
		$month.selecter("update");
		
		$monthHolder.removeClass("disabled");
	});
	
	$button.on("click", function(e){
		e.preventDefault();
		e.stopPropagation();
		
		if ( ! $year.val() || ! $month.val()) {
			return;
		}
		
		var link = baseURL+"?filter[year]="+$year.val()+"&filter[month]="+$month.val();
		if ($order.val()) {
			link += "&order="+$order.val();
		} 
		
		s.ajax.load(link, $target, {
			scrollToTarget: false,
			counters: false,
			insertHandler: "filterHandler"
		});

		$buttonReset.closest('.btn-reset').show();
	});

	$buttonReset.on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$year.val('');
		$year.selecter("update");

		$month.val('');
		$month.html("<option value=\"\"></option>");
		$month.selecter("update");
		$monthHolder.addClass("disabled");

		var link = baseURL;

		s.ajax.load(link, $target, {
			scrollToTarget: false,
			counters: false,
			insertHandler: "filterHandler"
		});

		$buttonReset.closest('.btn-reset').hide();
	});
};
s.initReleaseDetail = function(context){
	var $hiddenBlocks = context.find(".hidden-block");
	context.find(".expanded-block .expanded-opener").on("click", function(e){
		e.preventDefault();
		var $this = $(this);
		if( ! $hiddenBlocks.is(':animated')){
			if ($this.hasClass('opened')){
				$this.closest('.expanded-block').find('.hidden-block').slideUp(300, function(){
					$this.removeClass('opened')
				})
			} else {
				$this.closest('.expanded-block').find('.hidden-block').slideDown(300, function(){
					$this.addClass('opened')
				})
			}
		}
	});
};

s.initNews = function(context){
	var $holder = context.find('.news-list');

	if ($holder.size()) {
		$holder.masonry({
			itemSelector: '.news-list-item',
			columnWidth: '.grid-sizer',
			gutter: '.gutter-sizer',
			percentPosition: true
		})
	}
};

s.initFancybox = function (context) {
	var $holder = context.find(".fancybox-thumb");

	if ($holder.size()) {
		$holder.fancybox({
			padding: 0,
			prevEffect: 'none',
			nextEffect: 'none',
			helpers: {
				thumbs: {
					width: 112,
					height: 90
				},
				overlay: {
					locked: true
				}
			},

			afterLoad: function () {
				$.extend(this, {
					tpl: {
						image: '<div class="fancy-wrap"><ul class="social"><li><a href="' + $(this.element).data('vk-link') + '" class="s s-vk"></a></li><li><a href="' + $(this.element).data('facebook-link') + '" class="s s-facebook"></a></li><li><a href="' + $(this.element).data('tw-link') + '" class="s s-twitter"></a></li></ul><div class="fancy-visual"><img class="fancybox-image" src="{href}" alt="" /></div></div>',
						closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"><i class="fa fa-times" aria-hidden="true"></i></a>',
						next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
						prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
					}
				});
			},
			afterShow: function () {
				s.dom.$html.find('.fancy-wrap .social a').on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();

					window.open(
						this.href,
						'',
						'menubar=no,' +
						'toolbar=no,' +
						'resizable=yes,' +
						'scrollbars=yes,' +
						'height=420,' +
						'width=980,' +
						'left=40,' +
						'top=40'
					);
				});
			}
		});
	}
};

s.initRoyalSlider = function(context, iframe_list) {
	var holder = s.dom.$main.find('#video-gallery');
	if (parseInt(holder.length) > 0) {
		
		var slider = holder.royalSlider({
			arrowsNav: false,
			fadeinLoadedSlide: true,
			controlNavigationSpacing: 0,
			controlNavigation: 'thumbnails',

			thumbs: {

				spacing: 0,
				paddingBottom: 0
			},
			keyboardNavEnabled: true,
			imageScaleMode: 'fill',
			imageAlignCenter: true,
			slidesSpacing: 0,
			loop: false,
			loopRewind: true,
			numImagesToPreload: 3,
			video: {
				autoHideArrows: true,
				autoHideControlNav: false,
				autoHideBlocks: true
			},
			autoScaleSlider: true,
			autoScaleSliderWidth: 1140,
			autoScaleSliderHeight: 755,

			/* size of all images http://help.dimsemenov.com/kb/royalslider-jquery-plugin-faq/adding-width-and-height-properties-to-images */
			imgWidth: 1140,
			imgHeight: 533

		}).data('royalSlider');
		
		if (iframe_list) {
			slider.ev.on('rsOnCreateVideoElement', function(e, url) {
				// url - path to video from data-rsVideo attribute
				// slider.videoObj - jQuery object that holds video HTML code
				// slider.videoObj must be IFRAME, VIDEO or EMBED element, or have class rsVideoObj
				if (iframe_list && iframe_list[url]) {
					slider.videoObj = $(iframe_list[url]);
				}
			});
		}
	}
};

s.initTourPage = function(context) {
	
	var context = context || s.dom.$main;
	
	var cities = context.find('#js-cities');
	var cityInfo = context.find('#js-city-info');
	var artists = context.find('#js-artists');
	var artistsInfo = context.find('#js-artists-info');
	var place = context.find('#js-place');
	
	cities.on('click', 'a', function () {
		var _this = $(this);
		
		artists.empty();
		
		_this.siblings().removeClass('active');
		_this.addClass('active');
		
		cityInfo.find('strong').text(_this.text());
		cityInfo.find('span').text(_this.data('info'));
		
		artists.load('/assets/default/pages/tour/artists/'+_this.data('code')+'.html');
		
		place.load('/assets/default/pages/tour/places/'+_this.data('code')+'.html')
	});
	
	artists.on('click', '.js-item > a', function (e) {
		e.preventDefault();
		e.stopPropagation();
		
		var $this = $(this);
		var $id = $this.parent('.js-item').data('id');
		var $idHtml = artistsInfo.find($id).html();

		if (s.popup.cache.length) {
			s.popup.closeAll();
		} else if($idHtml) {
			s.popup.load("#tpl_artist", function($popup){
				s.dom.$header.removeClass('fixed');

				s.popup.closeAll();
				$this.addClass("active");
				$popup.on("popup.close", function(){
					$this.removeClass("active");
					s.dom.$body.attr("style", "");
				});

				$popup.find("#js-artist-content")
					.html($idHtml);

				s.dom.$body.css({
					'overflow': 'hidden'
				});

				s.popup.show($popup);
			});
		}
	});
}

s.wrapIframes = function(context){
	$('iframe', context ? $(context) : context)
		.each(s.wrapIframeHandler);
};
s.wrapIframeHandler = function(index, iframe){
	var el = $(iframe);

	if (el.attr('src').indexOf('soundcloud') !== -1)
	{
		return;
	}

	if (el.attr('style') || el.attr('class'))
		return;
	if (el.parent('.iframeWrapper').length)
		return;
	if (el.closest('.videoWrapper').length)
		return;
	
	el.wrap('<div class="iframeWrapper"></div>');
	var w = +el.attr('width');
	var h = +el.attr('height');
	if (w && h)
	{
		el.parent().css('paddingBottom', h*100/w +'%');
	}
	el.addClass('wrapped-iframe');
};